<script lang="ts" setup>
    import { cookieConsentServices, type CookieConsentServiceKey } from '~/utils/cookieConsentServices';

    const props = defineProps<{
        serviceKey: CookieConsentServiceKey;
        messageKey?: string;
    }>();

    const { locale } = useI18n();

    const serviceConfig = computed(() => cookieConsentServices[props.serviceKey]);
</script>

<template>
    <div class="consent-message">
        <img
            :src="serviceConfig.logoSrc"
            :alt="serviceConfig.logoAlt"
            class="consent-message-logo"
        />

        <i18n-t
            :keypath="messageKey ?? 'genericCookieConsent.message'"
            :locale="locale"
            tag="p"
            class="consent-message-text"
        >
            <template #brandName>
                <strong>{{ serviceConfig.brandName }}</strong>
            </template>

            <template #privacyLink>
                <NuxtLink
                    :to="$t('genericCookieConsent.privacyLinkUrl')"
                    class="consent-message-link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {{ $t('genericCookieConsent.privacyLinkText') }}
                </NuxtLink>
            </template>
        </i18n-t>
    </div>
</template>

<style scoped>
    .consent-message {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: var(--spacing);
        text-align: center;
    }

    .consent-message-logo {
        max-height: var(--spacing--2);
        max-width: var(--spacing--16);
    }

    .consent-message-text {
        margin: 0;
    }

    .consent-message-link {
        text-decoration: underline;
    }
</style>
